module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAUVBMVEUAAABmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmbv7+////98fHzs7Ox/f3/y8vJ6enrl5eXa2trU1NSdidAsAAAAEHRSTlMA6gWTWEwQ+sbFrIB/+JaBUjOK3gAAALRJREFUKM+Fk1sSgyAMRQkR322vin3tf6G1TsqYgpPzyZnABRKX8IFbahpqOXj3Tz0QEnSrta0ICqoO0jMyrj7ZHgX6n2cUYTkXJ1R7ZjrT9M0/YucVFwhrfGNn2HJJcZynRex9fkq5d0FKlmnzYuNDFoNjKC82he+gvLLoHEF5ZUHuAuXn6WDRKL1mOttcecqiKd9lF1OejWcxHtX4EuNDjXYwmsloRaORrTEQ6rE4RMYIfgA4Oywnu1EtVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_close_video.png
// module id = sSYW
// module chunks = 16